import { loginActionData } from './login/login-action';
import { emailActionData } from './email/email-action';
import { accountActions } from './account-action';
import { navigationActionData } from './navigation-action';
import { collectionActions } from './collectionAction';
import { modalActions } from './modal-action';
import { smsActionData } from './sms/sms-action';
import { refreshActions } from './refreshAction';
import { showComponentActions } from './showComponentAction';
import { hideComponentActions } from './hideComponentAction';
import { externalApiActions } from './externalApiAction';
import { importExportAcions } from './importExportAction';
import { formActions } from './formAction';
import { browserActions } from './browserAction';
import { multiTenantActions } from './multiTenantAction';
import { chatGPTActions } from './chatGPTActions';
import { permissionActionData } from './permission-action';
import { supabaseActions } from './externalSource/supabaseAction';
import { verify2FAData } from './login/2FA';
import { imaginePayActions } from './imaginePayAction';
import { amazonTextractActions } from './amazonTextractAction';
import { directusActions } from './externalSource/directusAction';
import { appwriteActions } from './externalSource/appwriteAction';
import { xanoActions } from './externalSource/xanoAction';
import { updateCellDataAction } from './tabulator/updateCellDataAction';
import { loanActions } from './loanActions';
import { awsSnsActionData } from './awsSns/aws-sns-action';
import { oAuth2ActionData } from './login/oAuth2/oAuth-actions';
import { docusignActionData } from './docusign/docusign-action';
import { otpAuthenticatorActions } from './otpAuthenticator/otpAuthenticatorActions';
import { textAnonymizationActionData } from './text-anonymization/text-anonymization-action';
import { typesenseSearchActions } from './typesense-search/typesenseSearchActions';
import { triggerCustomFunction } from './customFunction/triggerCustomFunction';
import { socketActionData } from './socket-io/socketIOActions';
import { metaDataTableActions } from './metaData/metaDataAction';

export const ActionCategoryList = [
  {
    category: 'Login / Signup',
    items: loginActionData,
  },
  {
    category: 'Snippet / Modal Popup',
    items: modalActions,
  },
  {
    category: 'Show / Hide Sections',
    items: [...showComponentActions, ...hideComponentActions],
  },
  {
    category: 'Navigation',
    items: [...navigationActionData, ...refreshActions],
  },
  {
    category: 'Notification',
    items: [
      ...emailActionData,
      ...smsActionData,
      ...accountActions,
      ...awsSnsActionData,
      ...socketActionData,
    ],
  },
  {
    category: 'Form',
    items: [...formActions],
  },
  {
    category: 'Collection',
    items: collectionActions,
  },
  // {
  //   category: 'Data Sources',
  //   items: dataSourceActions,
  // },
  { category: 'Multi Tenant', items: multiTenantActions },
  {
    category: 'External APIs',
    items: externalApiActions,
  },
  {
    category: 'Supabase',
    items: supabaseActions,
  },
  {
    category: 'Directus',
    items: directusActions,
  },
  {
    category: 'Appwrite',
    items: appwriteActions,
  },
  {
    category: 'Xano',
    items: xanoActions,
  },
  {
    category: 'Tabulator',
    items: updateCellDataAction,
  },
  {
    category: 'Custom Function',
    items: triggerCustomFunction,
  },
  {
    category: 'OAuth2.0',
    items: oAuth2ActionData,
  },
  {
    category: 'AI / ChatGPT',
    items: chatGPTActions,
  },
  {
    category: 'Import / Export Collection Data',
    items: importExportAcions,
  },
  {
    category: 'Permission',
    items: permissionActionData,
  },
  { category: '2 Factor Authentication', items: verify2FAData },
  { category: 'Imagine Pay', items: imaginePayActions },
  { category: 'Loan Management', items: loanActions },
  { category: 'OCR to Text', items: amazonTextractActions },
  { category: 'OTP Authentication', items: otpAuthenticatorActions },
  { category: 'Typesense Search', items: typesenseSearchActions },
  { category: 'Meta Data Table', items: metaDataTableActions },
  {
    category: 'Browser Storage', // Keep this category always at the end.
    items: [...browserActions],
  },
  { category: 'Docusign', items: docusignActionData },
  { category: 'Text Anonymization', items: textAnonymizationActionData },
];

export const ActionList = [
  ...loginActionData,
  ...emailActionData,
  ...smsActionData,
  ...accountActions,
  ...modalActions,
  ...navigationActionData,
  ...collectionActions,
  // ...dataSourceActions,
  ...refreshActions,
  ...showComponentActions,
  ...hideComponentActions,
  ...externalApiActions,
  ...chatGPTActions,
  ...importExportAcions,
  ...formActions,
  ...browserActions,
  ...multiTenantActions,
  ...supabaseActions,
  ...directusActions,
  ...appwriteActions,
  ...xanoActions,
  ...updateCellDataAction,
  ...verify2FAData,
  ...imaginePayActions,
  ...loanActions,
  ...awsSnsActionData,
  ...oAuth2ActionData,
  ...amazonTextractActions,
  ...docusignActionData,
  ...otpAuthenticatorActions,
  ...textAnonymizationActionData,
  ...typesenseSearchActions,
  ...triggerCustomFunction,
  ...socketActionData,
  ...metaDataTableActions,
];
